
export default {

  displayForm (state) {
    state.displayForm = true
  },

  hideForm (state) {
    state.displayForm = false
  },

  setFormData (state, { name, value }) {
    if (typeof state.formData[name] !== 'undefined') {
      state.formData[name] = value
    }
  },

  setFormSuccess (state, { message }) {
    state.formSuccess = true
    state.formError = false
    state.formAlertMessage = message
  },

  setFormError (state, { message }) {
    state.formSuccess = false
    state.formError = true
    state.formAlertMessage = message
  },

  setFormSendState (state, sendingState) {
    state.formSending = sendingState
    if (sendingState) {
      state.formSuccess = false
      state.formError = false
    }
  }
}
